import { createStore } from 'redux';
import { createWrapper, HYDRATE } from 'next-redux-wrapper';
import combinedReducer from '../reducers';

const reducer = (state, action) => {
  if (action.type === HYDRATE) {
    return {
      ...state,
      ...action.payload
    };
  }
  return combinedReducer(state, action);
};

const makeStore = () => createStore(reducer);

export default createWrapper(makeStore);
